import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import styled from 'styled-components';
import InProgressDot from '../ContentCards/ReducedContentCard/subcomponents/InProgressDot';
import { FormattedList, FormattedMessage } from 'LearningCenterUI/components/I18n';
import { FILTER_CONSTS } from '../../constants/TopFilterConstants';
import { usePlaylist, usePlaylistRemainingItemsAndProgress } from '../../features/savedItems';
const ReadoutLessonBox = styled(UIBox).withConfig({
  displayName: "PlaylistCardTimeReadout__ReadoutLessonBox",
  componentId: "sc-1j5t1dh-0"
})(["display:flex;&::after{content:'';margin:0 10px 0 10px;display:inline-flex;align-self:center;height:100%;}"]);
const InProgressLargeCardDot = styled(InProgressDot).withConfig({
  displayName: "PlaylistCardTimeReadout__InProgressLargeCardDot",
  componentId: "sc-1j5t1dh-1"
})(["bottom:-9px;margin-left:3px;margin-right:9px;"]);
export const PlaylistCardTimeReadout = ({
  playlistId
}) => {
  const {
    playlistProgressLoading,
    status,
    remainingProgressItemCount
  } = usePlaylistRemainingItemsAndProgress(playlistId);
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId);
  const showProgress = status && status !== FILTER_CONSTS.STATUSES.NOT_STARTED;
  if (playlistProgressLoading || playlistLoading || !playlist) return null;
  const {
    itemsCount
  } = playlist;
  return /*#__PURE__*/_jsxs(UIFlex, {
    children: [showProgress && /*#__PURE__*/_jsx(InProgressLargeCardDot, {}), showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(ReadoutLessonBox, {
        children: /*#__PURE__*/_jsx(FormattedList, {
          exclusive: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.reducedContentCards.numItemsRemaining",
            options: {
              remainingNumber: remainingProgressItemCount,
              totalNumber: itemsCount
            }
          })
        })
      })
    }), !showProgress && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.reducedContentCards.items",
        options: {
          itemsCount
        }
      })
    })]
  });
};